<template>
  <div class="youth-staff-list">
    <div v-if="staffList.length" class="coach-page">
      <div v-for="(item, index) in staffList" :key="index" class="item">
        <img :src="imageSrc(item.img)" class="coach-img" alt="">
        <ul>
          <li>
            <p class="name">{{item.koNm}}</p>
            <p class="sub">{{item.engNm}}</p>
          </li>
          <li>
            <p>{{item.position}}</p>
            <p>{{item.birthday}}</p>
            <p v-html="item.education"></p>
          </li>
        </ul>
      </div>
    </div>
    <div v-else>
      <PageComingSoon />
    </div>
  </div>
</template>

<script>
import PageComingSoon from '@/components/Common/PageComingSoon.vue';
import staff from '@/components/Youth/Json/staff'

export default {
  name: 'YouthStaffList',
  components: {PageComingSoon},
  props: ['routeName'],
  data() {
    return {
      staffList: [],
    }
  },
  mounted () {
    this.getStaffList();
  },
  methods: {
    getStaffList() {
      if(this.routeName.includes('listU18')) {
        this.staffList = staff.u18;
      }
      if(this.routeName.includes('listU15')) {
        this.staffList = staff.u15;
      }
      if(this.routeName.includes('listU12')) {
        this.staffList = staff.u12;
      }
    },
    imageSrc(imgSrc) {
      return require('@/assets/img/youth/staff/'+imgSrc+'.png');
    },
  }
}
</script>
